module.exports = __webpack_public_path__ + "static/media/energy-flexibility-simulator-img-005.c45b5a3c.jpg";